import React from 'react';
import MuiButton from '@material-ui/core/Button';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import styled from 'styled-components/macro';
import useTranslations from '../hooks/useTranslations';
import gsap from 'gsap';

const Button = styled(MuiButton)`
  && {
    text-transform: none;
    border-radius: 20px;
    padding: 0 10px;
  }
`;
const Scroll2TopButton = ({ containerRef = window, ...props }) => {
  const t = useTranslations();
  return (
    <Button
      size="small"
      variant="outlined"
      color="primary"
      endIcon={<ArrowUpwardIcon />}
      {...props}
      onClick={() => gsap.to(containerRef, { duration: 1, scrollTo: 0 })}
    >
      {t('button.scroll2Top')}
    </Button>
  );
};

export default Scroll2TopButton;
